// extracted by mini-css-extract-plugin
export var DesktopCompareAspect = "sauna-comparison-chart-module--DesktopCompareAspect--2eac4";
export var SaunaNameDesktopStyles = "sauna-comparison-chart-module--SaunaNameDesktopStyles--aa1d4";
export var columnName = "sauna-comparison-chart-module--columnName--a8e13";
export var imageLink = "sauna-comparison-chart-module--imageLink--8f37d";
export var mobileColumn = "sauna-comparison-chart-module--mobileColumn--4af5e";
export var mobileImg = "sauna-comparison-chart-module--mobileImg--eabfb";
export var mobileSaunaName = "sauna-comparison-chart-module--mobileSaunaName--327cc";
export var secondaryCtaStyle = "sauna-comparison-chart-module--secondaryCtaStyle--8742c";
export var table = "sauna-comparison-chart-module--table--d795e";
export var tableContainer = "sauna-comparison-chart-module--tableContainer--b3a0b";
export var tableData = "sauna-comparison-chart-module--tableData--61c95";
export var woodIcon = "sauna-comparison-chart-module--woodIcon--a962c";
export var wrapper = "sauna-comparison-chart-module--wrapper--f048c";